module.exports = __webpack_public_path__ + "static/img/093.de65188.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/lkpy/093.png
// module id = Unp/
// module chunks = 0